import { Box } from '@src/atoms/Box';
import { InputIcon } from '@src/atoms/InputIcon';
import { TIconElement } from '@src/models/props';
import classnames from 'classnames';
import React, { FC, ReactNode, useMemo } from 'react';

import styled from './SwitchLabelValue.scss';

export interface ISwitchLabelValueProps {
  label: ReactNode;
  preIcon?: TIconElement;
  postIcon?: TIconElement;
}

export const SwitchLabelValue: FC<ISwitchLabelValueProps> = ({ label, preIcon, postIcon }) => {
  // Если переданы данные для тултипа, задаем кастомные стили и выставляем иконку
  const isPreIconTooltip = typeof preIcon === 'object' && !!preIcon?.tooltip;
  const isPostIconTooltip = typeof postIcon === 'object' && !!postIcon?.tooltip;
  const classes = classnames(styled.root, {
    [styled.tooltip]: isPreIconTooltip || isPostIconTooltip,
  });

  const config = useMemo(() => {
    if (isPreIconTooltip) {
      return {
        ...preIcon,
        ...{ name: 'question' },
      };
    }
    if (isPostIconTooltip) {
      return {
        ...postIcon,
        ...{ name: 'question' },
      };
    }
    return undefined;
  }, [isPreIconTooltip, isPostIconTooltip, preIcon, postIcon]);

  return (
    <Box className={classes}>
      {preIcon && <InputIcon size={'sm'} config={config as TIconElement} view={'basicBlack'} />}
      {label}
      {postIcon && <InputIcon size={'sm'} config={config as TIconElement} view={'basicBlack'} />}
    </Box>
  );
};
